module.exports = __webpack_public_path__ + "static/media/paisagemudf-cmn.bb00cfd5.jpg";